import { Observable } from "rxjs";
import { StandingDataItemModel } from "../models/standing-data-item.model";

export abstract class BaseStandingDataService {
    abstract getAll(): Observable<StandingDataItemModel[]>;
    abstract changeOrder(id: string, order: number): Observable<void>;
}
